import cn from "@/util/cn"
import type { DashboardTab } from "../dashboardData"

type DashboardTabsProps = {
  value: DashboardTab
  onChange: (tab: DashboardTab) => void
}

const TABS: { value: DashboardTab; label: string }[] = [
  { value: "overview", label: "Overview" },
  { value: "meal-logs", label: "Food log" },
  { value: "measurement", label: "Measurements" },
]

const DashboardTabs = ({ value, onChange }: DashboardTabsProps) => (
  <div role="tablist" className="mb-4 mt-4 flex rounded-md border border-secondary bg-white p-1">
    {TABS.map((tab) => {
      const active = tab.value === value
      return (
        <button
          key={tab.value}
          role="tab"
          aria-selected={active}
          onClick={() => onChange(tab.value)}
          className={cn(
            "flex-1 rounded px-3 py-2 text-sm font-medium transition-colors",
            active
              ? "bg-primary text-primary-contrast"
              : "text-primary-contrast/70 hover:bg-secondary",
          )}
        >
          {tab.label}
        </button>
      )
    })}
  </div>
)

export default DashboardTabs
